var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
			!_vm.loading ||
			['login', ..._vm.allowedPagesOutOfFinancialFileContext].includes(_vm.$route.name) ||
			_vm.$route.name?.includes('statistics')
		)?_c('v-app',[(
				_vm.isAuthenticated && (
					(
						!!_vm.isFileSelected &&
						!['login', 'splash-window'].includes(_vm.$route.name)
					) ||
					_vm.$route.name?.includes('statistics') ||
					_vm.allowedPagesOutOfFinancialFileContext.includes(_vm.$route.name)
				)
			)?_c('Navigation'):_vm._e(),_c('v-main',[_c('router-view',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function({ item }){return [_c('bee-breadcrumbs',{attrs:{"show-only-title":!!item}}),_c('bee-snackbar',{ref:"snackbar"})]}}],null,false,3011109289)})],1)],1):(_vm.loading && _vm.$route.name != 'login')?_c('v-app',[_c('v-main',[_c('splash-window'),_c('bee-snackbar',{ref:"snackbar"})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }